import getCalendarSurfaceStore from '../store/store';
import refreshEventsCount from '../actions/refreshEventsCount';
import updateEventsCount from '../mutators/updateEventsCount';
import { areDateRangesEqual, createWeekDateRange, DateRange } from 'mini-datetime-utils';
import { CalendarNavigationMode } from 'fabric-calendar';
import { endOfDay, endOfMonth, startOfMonth } from 'owa-datetime';
import { getCalendarEventsCountsForADateRange } from 'mini-calendar-events-store';
import { getFirstDayOfWeek } from 'mini-calendar-utils/lib/getFirstDayOfWeek';
import { orchestrator } from 'satcheljs';
import { traceAndReject } from 'error-handling';

let activeRangeForRefreshEventsCount: DateRange = null;

/**
 * Get the latest events count for days around the pivot date or selected date and
 * update the events count map in calendar surface store
 */
export default orchestrator(refreshEventsCount, async actionMessage => {
    const {
        navigationMode,
        eventsCountInfo: { range: existingRange },
        selectedDate,
    } = getCalendarSurfaceStore();
    const { pivotDate = selectedDate, forceRefresh } = actionMessage;

    const newRange: DateRange =
        navigationMode === CalendarNavigationMode.Week
            ? createWeekDateRange(getFirstDayOfWeek(), pivotDate)
            : { start: startOfMonth(pivotDate), end: endOfMonth(pivotDate) };

    activeRangeForRefreshEventsCount = newRange;

    // Refresh the counts in the store only if the old range and the new range are not same or if it's a force refresh
    if (forceRefresh || !areDateRangesEqual(existingRange, newRange)) {
        try {
            const eventsCount = await getCalendarEventsCountsForADateRange(
                newRange.start,
                endOfDay(newRange.end)
            );

            /**
             * 1. Date picker can get its range changed again while the above request is in progress
             * 2. In this case, it is important to prevent updates from response no longer needed.
             * 3. Example: Request made for 1st Sept - 30 Sept first, then picker moved to October so request went for 1st Oct - 31st Oct
             * 4. Now again the picker moved to September, so it is required to discard updates for October
             * 5. Otherwise picker will show dates with no dots representing no events
             */
            if (areDateRangesEqual(activeRangeForRefreshEventsCount, newRange)) {
                updateEventsCount(newRange, eventsCount);
            }
        } catch (error) {
            if (error !== 'REJECT_AS_STALE') {
                traceAndReject('refreshEventsCountOrchestrator', error);
            }
        }
    }
});
